var _style, _g, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotteaspirante(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.6 198",
    style: {
      enableBackground: "new 0 0 230.6 198"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BABABA;}\n\t.st1{fill:#C8C9CA;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:#7A7C83;}\n\t.st9{fill:#B6B7B8;}\n\t.st10{fill:#F6F6F6;}\n\t.st11{opacity:0.3;}\n\t.st12{opacity:0;}\n\t.st13{opacity:0.0909;}\n\t.st14{opacity:0.1818;}\n\t.st15{opacity:0.2727;}\n\t.st16{opacity:0.3636;}\n\t.st17{opacity:0.4545;}\n\t.st18{opacity:0.5455;}\n\t.st19{opacity:0.6364;}\n\t.st20{opacity:0.7273;}\n\t.st21{opacity:0.8182;}\n\t.st22{opacity:0.9091;}\n\t.st23{fill:#383A45;}\n\t.st24{fill:url(#SVGID_7_);}\n\t.st25{fill:url(#SVGID_8_);}\n\t.st26{fill:url(#SVGID_9_);}\n\t.st27{fill:url(#SVGID_10_);}\n\t.st28{fill:url(#SVGID_11_);}\n\t.st29{fill:url(#SVGID_12_);}\n\t.st30{fill:url(#SVGID_13_);}\n\t.st31{fill:url(#SVGID_14_);}\n\t.st32{fill:url(#SVGID_15_);}\n\t.st33{fill:url(#SVGID_16_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REPERES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "195.93,111.91 98.62,168.23 34.66,131.45 131.98,75.13  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "195.93,127.01 98.53,183.29 98.53,168.2 195.93,111.91  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.663,
    y1: 157.3721,
    x2: 98.5309,
    y2: 157.3721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDC"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "98.53,183.29 34.66,146.55 34.66,131.45 98.53,168.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.663,
    y1: 121.6819,
    x2: 195.9335,
    y2: 121.6819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4431,
    style: {
      stopColor: "#E4E4E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2D2D3"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "195.93,111.91 98.62,168.23 34.66,131.45 131.98,75.13  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.9112,
    y1: 80.2906,
    x2: 95.535,
    y2: 80.2906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDC"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "95.54,48.95 95.53,127 68.91,111.63 68.91,33.58  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "128.15,108.13 95.54,127 95.54,48.96 128.15,30.08  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.9116,
    y1: 31.832,
    x2: 128.1493,
    y2: 31.832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5969,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDC"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "128.15,30.08 95.53,48.95 68.91,33.58 101.53,14.71  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.5138,
    y1: 94.0938,
    x2: 99.5262,
    y2: 33.3826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#8C8C8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "125.86,29.91 102.84,43.23 102.84,43.23 95.39,47.54 71.01,33.56 101.39,15.98 101.47,15.94  101.56,15.88  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.3302,
    y1: 69.2161,
    x2: 88.6058,
    y2: 33.1102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#6D6D6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6B7B8"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "101.47,15.94 101.47,42.44 101.39,44.02 95.39,47.54 71.01,33.56 101.39,15.98  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,102.07 77.76,101.63 74.38,99.67 74.38,100.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,99.67 74.22,99.58 74.22,100.22 74.38,100.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,100.12 74.22,100.22 77.76,102.27 77.76,102.07  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,100.79 77.76,100.34 74.38,98.37 74.38,98.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,98.37 74.22,98.29 74.22,98.93 74.38,98.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,98.83 74.22,98.93 77.76,100.99 77.76,100.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,99.5 77.76,99.05 74.38,97.09 74.38,97.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,97.09 74.21,97 74.21,97.64 74.38,97.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,97.55 74.21,97.64 77.76,99.7 77.76,99.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,98.21 77.76,97.76 74.38,95.8 74.38,96.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,95.8 74.21,95.72 74.2,96.36 74.38,96.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,96.26 74.2,96.36 77.76,98.41 77.76,98.21  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,96.92 77.76,96.47 74.38,94.52 74.38,94.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,94.52 74.22,94.42 74.22,95.07 74.38,94.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,94.97 74.22,95.07 77.76,97.12 77.76,96.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,95.64 77.76,95.18 74.38,93.24 74.38,93.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,93.24 74.22,93.13 74.22,93.78 74.38,93.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,93.69 74.22,93.78 77.76,95.83 77.76,95.64  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,94.36 77.76,93.9 74.38,91.95 74.38,92.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,91.95 74.22,91.85 74.22,92.49 74.38,92.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,92.4 74.22,92.49 77.76,94.54 77.76,94.36  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,93.07 77.76,92.61 74.38,90.66 74.38,91.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,90.66 74.22,90.56 74.22,91.2 74.38,91.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,91.11 74.22,91.2 77.76,93.26 77.76,93.07  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,91.78 77.76,91.33 74.38,89.37 74.38,89.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,89.37 74.22,89.28 74.22,89.92 74.38,89.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,89.82 74.22,89.92 77.76,91.97 77.76,91.78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.76,90.49 77.76,90.04 74.38,88.08 74.38,88.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "74.38,88.08 74.22,87.99 74.22,88.63 74.38,88.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.38,88.53 74.22,88.63 77.76,90.68 77.76,90.49  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,104.81 82.5,104.36 79.13,102.4 79.12,102.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.13,102.4 78.96,102.31 78.96,102.95 79.12,102.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.12,102.85 78.96,102.95 82.5,105.01 82.5,104.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,103.52 82.5,103.08 79.13,101.11 79.13,101.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.13,101.11 78.96,101.03 78.96,101.67 79.13,101.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.13,101.57 78.96,101.67 82.5,103.72 82.5,103.52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,102.24 82.5,101.79 79.12,99.83 79.12,100.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.12,99.83 78.95,99.74 78.95,100.38 79.12,100.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.12,100.28 78.95,100.38 82.5,102.44 82.5,102.24  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,100.94 82.5,100.5 79.12,98.54 79.12,99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.12,98.54 78.94,98.45 78.94,99.1 79.12,99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.12,99 78.94,99.1 82.5,101.14 82.5,100.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,99.66 82.5,99.21 79.13,97.26 79.13,97.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.13,97.26 78.95,97.16 78.95,97.8 79.13,97.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.13,97.71 78.95,97.8 82.5,99.86 82.5,99.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,98.37 82.5,97.92 79.13,95.97 79.13,96.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.13,95.97 78.96,95.87 78.96,96.51 79.13,96.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.13,96.42 78.96,96.51 82.5,98.57 82.5,98.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,97.09 82.5,96.64 79.12,94.68 79.13,95.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.12,94.68 78.96,94.58 78.96,95.23 79.13,95.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.13,95.13 78.96,95.23 82.5,97.27 82.5,97.09  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,95.8 82.5,95.35 79.13,93.39 79.13,93.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.13,93.39 78.96,93.3 78.96,93.94 79.13,93.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.13,93.84 78.96,93.94 82.5,95.99 82.5,95.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,94.52 82.5,94.07 79.13,92.11 79.13,92.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.13,92.11 78.96,92.01 78.96,92.66 79.13,92.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.13,92.56 78.96,92.66 82.5,94.71 82.5,94.52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "82.5,93.23 82.5,92.78 79.12,90.82 79.12,91.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.12,90.82 78.96,90.73 78.96,91.37 79.12,91.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "79.12,91.27 78.96,91.37 82.5,93.42 82.5,93.23  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,107.55 87.25,107.1 83.86,105.14 83.86,105.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.86,105.14 83.7,105.05 83.69,105.69 83.86,105.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.86,105.59 83.69,105.69 87.25,107.74 87.25,107.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,106.26 87.25,105.81 83.87,103.85 83.87,104.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.87,103.85 83.69,103.76 83.7,104.4 83.87,104.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.87,104.3 83.7,104.4 87.25,106.46 87.25,106.26  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,104.97 87.25,104.53 83.86,102.57 83.86,103.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.86,102.57 83.68,102.48 83.69,103.12 83.86,103.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.86,103.02 83.69,103.12 87.25,105.17 87.25,104.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,103.68 87.24,103.24 83.85,101.28 83.85,101.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.85,101.28 83.68,101.19 83.68,101.83 83.85,101.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.85,101.73 83.68,101.83 87.25,103.88 87.25,103.68  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,102.4 87.25,101.95 83.87,99.99 83.86,100.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.87,99.99 83.69,99.9 83.69,100.55 83.86,100.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.86,100.45 83.69,100.55 87.25,102.59 87.25,102.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,101.11 87.25,100.66 83.87,98.71 83.87,99.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.87,98.71 83.69,98.61 83.69,99.25 83.87,99.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.87,99.16 83.69,99.25 87.25,101.31 87.25,101.11  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,99.83 87.25,99.37 83.86,97.42 83.86,97.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.86,97.42 83.69,97.32 83.7,97.96 83.86,97.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.86,97.87 83.7,97.96 87.25,100.02 87.25,99.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,98.54 87.25,98.09 83.87,96.13 83.87,96.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.87,96.13 83.7,96.03 83.7,96.68 83.87,96.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.87,96.58 83.7,96.68 87.25,98.73 87.25,98.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,97.25 87.25,96.8 83.86,94.84 83.86,95.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.86,94.84 83.7,94.75 83.7,95.39 83.86,95.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.86,95.3 83.7,95.39 87.25,97.44 87.25,97.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.25,95.96 87.25,95.51 83.86,93.56 83.86,94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "83.86,93.56 83.69,93.46 83.69,94.11 83.86,94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "83.86,94 83.69,94.11 87.25,96.16 87.25,95.96  "
  }))))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.03,133.5c-0.29,0-0.48-1.14-0.48-1.5c0-0.48,0.34-1.07,0.76-1.31c0.13-0.08,0.25-0.11,0.37-0.11 c0.29,0,0.48,0.23,0.48,0.59c0,0.48-0.35,1.98-0.77,2.22C176.26,133.46,176.14,133.5,176.03,133.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.31,130.69c0.15-0.09,0.29-0.08,0.4-0.06c0.26,0.05,0.43,0.23,0.43,0.57 c-0.01,0.47-0.35,1.86-0.76,2.1c-0.15,0.08-0.29,0.1-0.39,0.06c-0.27-0.02-0.43-1.08-0.42-1.43 C175.59,131.47,175.91,130.92,176.31,130.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M176.32,130.7c0.18-0.1,0.33-0.1,0.43-0.01c0.24,0.02,0.39,0.23,0.38,0.55 c-0.02,0.46-0.35,1.75-0.75,1.97c-0.17,0.1-0.33,0.09-0.42,0.01c-0.24-0.04-0.37-1.02-0.35-1.36 C175.63,131.43,175.94,130.92,176.32,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M176.32,130.71c0.2-0.12,0.38-0.09,0.46,0.03c0.21,0.03,0.35,0.24,0.33,0.53 c-0.02,0.44-0.35,1.63-0.74,1.85c-0.2,0.11-0.37,0.09-0.46-0.04c-0.21-0.06-0.32-0.96-0.29-1.28 C175.67,131.39,175.96,130.91,176.32,130.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M176.33,130.71c0.22-0.13,0.42-0.08,0.49,0.08c0.19,0.04,0.3,0.24,0.28,0.51 c-0.03,0.43-0.35,1.51-0.72,1.72c-0.22,0.13-0.42,0.08-0.49-0.08c-0.19-0.08-0.27-0.91-0.23-1.21 C175.71,131.35,175.99,130.91,176.33,130.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M176.33,130.72c0.25-0.14,0.46-0.08,0.52,0.13c0.16,0.05,0.26,0.24,0.23,0.49 c-0.04,0.42-0.35,1.4-0.71,1.6c-0.25,0.14-0.46,0.08-0.52-0.13c-0.16-0.11-0.22-0.85-0.16-1.14 C175.75,131.31,176.01,130.9,176.33,130.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M176.33,130.73c0.27-0.16,0.5-0.07,0.55,0.18c0.13,0.07,0.21,0.24,0.18,0.47 c-0.05,0.41-0.36,1.28-0.7,1.48c-0.27,0.16-0.5,0.07-0.56-0.17c-0.13-0.13-0.17-0.79-0.1-1.07 C175.79,131.27,176.04,130.9,176.33,130.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M176.34,130.73c0.29-0.17,0.54-0.06,0.59,0.23c0.11,0.08,0.17,0.24,0.13,0.45 c-0.06,0.4-0.36,1.16-0.69,1.35c-0.3,0.17-0.55,0.07-0.59-0.22c-0.11-0.15-0.11-0.73-0.04-1 C175.83,131.23,176.06,130.89,176.34,130.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M176.34,130.74c0.32-0.18,0.59-0.06,0.62,0.27c0.08,0.09,0.12,0.24,0.08,0.43 c-0.07,0.39-0.36,1.04-0.68,1.23c-0.32,0.19-0.59,0.06-0.62-0.27c-0.08-0.17-0.06-0.67,0.03-0.93 C175.87,131.19,176.09,130.88,176.34,130.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M176.35,130.74c0.34-0.2,0.63-0.05,0.65,0.32c0.05,0.1,0.07,0.24,0.04,0.41 c-0.08,0.38-0.36,0.93-0.67,1.11c-0.35,0.2-0.64,0.05-0.66-0.31c-0.05-0.19-0.01-0.61,0.09-0.86 C175.91,131.14,176.11,130.88,176.35,130.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M176.35,130.75c0.37-0.21,0.62-0.04,0.68,0.37c0.01,0.11,0.03,0.25-0.01,0.39 c-0.1,0.36-0.36,0.81-0.66,0.98c-0.37,0.21-0.68,0.05-0.69-0.36c-0.03-0.21,0.04-0.55,0.16-0.79 C175.94,131.1,176.13,130.87,176.35,130.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,130.76c0.39-0.22,0.71-0.04,0.71,0.42c0,0.45-0.32,1-0.71,1.23c-0.4,0.23-0.72,0.04-0.72-0.41 C175.63,131.54,175.95,130.98,176.35,130.76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M176.03,132.61c0.11,0,0.24-0.03,0.37-0.11c0.43-0.24,0.76-0.82,0.76-1.32c0-0.37-0.19-0.61-0.49-0.61 c-0.12,0-0.24,0.04-0.37,0.11c-0.43,0.24-0.77,0.84-0.77,1.32C175.53,132.37,175.73,132.61,176.03,132.61z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M178.76,131.92c-0.29,0-0.47-1.15-0.47-1.5c0-0.48,0.34-1.07,0.76-1.31c0.12-0.08,0.24-0.11,0.36-0.11 c0.29,0,0.48,0.23,0.48,0.6c0,0.48-0.34,1.98-0.76,2.22C179,131.88,178.88,131.92,178.76,131.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.05,129.12c0.15-0.09,0.28-0.09,0.39-0.06c0.26,0.06,0.44,0.24,0.43,0.58 c-0.01,0.47-0.34,1.87-0.75,2.1c-0.15,0.08-0.29,0.1-0.4,0.06c-0.27-0.02-0.42-1.09-0.41-1.43 C178.33,129.9,178.65,129.35,179.05,129.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M179.05,129.12c0.17-0.1,0.33-0.1,0.42-0.01c0.24,0.02,0.39,0.24,0.38,0.56 c-0.02,0.46-0.34,1.75-0.74,1.97c-0.17,0.1-0.33,0.09-0.43,0.01c-0.24-0.04-0.37-1.03-0.35-1.36 C178.37,129.85,178.67,129.34,179.05,129.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M179.05,129.13c0.2-0.12,0.38-0.09,0.46,0.03c0.21,0.03,0.35,0.24,0.33,0.54 c-0.02,0.44-0.35,1.63-0.73,1.85c-0.2,0.11-0.38,0.09-0.46-0.04c-0.21-0.06-0.32-0.97-0.29-1.29 C178.41,129.81,178.7,129.34,179.05,129.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M179.06,129.14c0.22-0.13,0.42-0.08,0.49,0.08c0.19,0.04,0.3,0.24,0.28,0.52 c-0.03,0.43-0.35,1.51-0.72,1.73c-0.22,0.13-0.42,0.08-0.49-0.08c-0.19-0.08-0.27-0.91-0.22-1.22 C178.45,129.77,178.72,129.33,179.06,129.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M179.06,129.14c0.25-0.14,0.46-0.08,0.52,0.13c0.16,0.05,0.26,0.24,0.23,0.49 c-0.04,0.42-0.35,1.39-0.71,1.6c-0.25,0.14-0.46,0.07-0.52-0.13c-0.16-0.11-0.21-0.85-0.16-1.14 C178.49,129.73,178.75,129.32,179.06,129.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M179.06,129.15c0.27-0.16,0.51-0.07,0.56,0.18c0.13,0.07,0.21,0.24,0.18,0.47 c-0.05,0.41-0.35,1.28-0.71,1.48c-0.27,0.15-0.5,0.07-0.55-0.18c-0.13-0.13-0.16-0.79-0.1-1.07 C178.53,129.69,178.77,129.32,179.06,129.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M179.07,129.15c0.3-0.17,0.55-0.06,0.59,0.23c0.11,0.08,0.17,0.24,0.14,0.45 c-0.06,0.4-0.36,1.16-0.7,1.35c-0.29,0.17-0.54,0.06-0.59-0.22c-0.11-0.15-0.11-0.73-0.03-1 C178.57,129.65,178.79,129.31,179.07,129.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M179.07,129.16c0.33-0.18,0.59-0.06,0.62,0.27c0.08,0.09,0.12,0.24,0.09,0.43 c-0.07,0.39-0.36,1.04-0.69,1.23c-0.32,0.18-0.59,0.06-0.62-0.27c-0.08-0.17-0.06-0.67,0.03-0.93 C178.6,129.61,178.82,129.31,179.07,129.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M179.07,129.17c0.35-0.2,0.64-0.05,0.66,0.32c0.05,0.1,0.07,0.24,0.04,0.41 c-0.08,0.37-0.36,0.92-0.68,1.11c-0.34,0.2-0.63,0.05-0.65-0.32c-0.05-0.19-0.01-0.61,0.09-0.86 C178.64,129.57,178.84,129.3,179.07,129.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M179.08,129.17c0.38-0.21,0.64-0.04,0.69,0.37c0.01,0.11,0.03,0.25-0.01,0.39 c-0.1,0.36-0.36,0.81-0.67,0.98c-0.37,0.21-0.67,0.05-0.68-0.36c-0.03-0.21,0.04-0.55,0.15-0.79 C178.68,129.53,178.86,129.3,179.08,129.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.08,129.18c0.4-0.22,0.73-0.04,0.73,0.42c0,0.45-0.32,1-0.72,1.23c-0.39,0.23-0.71,0.04-0.71-0.41 C178.37,129.97,178.69,129.41,179.08,129.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M178.76,131.03c0.12,0,0.24-0.03,0.37-0.11c0.43-0.25,0.77-0.83,0.77-1.32c0-0.37-0.19-0.61-0.5-0.61 c-0.11,0-0.24,0.04-0.37,0.11c-0.43,0.25-0.76,0.83-0.76,1.32C178.27,130.79,178.47,131.03,178.76,131.03z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.5,130.35c-0.29,0-0.48-1.15-0.48-1.51c0-0.48,0.34-1.06,0.76-1.3c0.13-0.08,0.25-0.11,0.37-0.11 c0.29,0,0.48,0.24,0.48,0.6c0,0.49-0.33,1.98-0.77,2.22C181.73,130.31,181.61,130.35,181.5,130.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.77,127.54c0.15-0.09,0.29-0.09,0.4-0.07c0.26,0.05,0.44,0.24,0.43,0.58 c-0.01,0.47-0.33,1.87-0.75,2.1c-0.15,0.08-0.29,0.1-0.39,0.06c-0.26-0.02-0.43-1.09-0.42-1.44 C181.05,128.32,181.38,127.77,181.77,127.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M181.78,127.55c0.18-0.1,0.34-0.1,0.43-0.02c0.24,0.02,0.39,0.24,0.38,0.56 c-0.02,0.46-0.34,1.75-0.74,1.98c-0.17,0.1-0.33,0.09-0.42,0.01c-0.24-0.04-0.38-1.03-0.36-1.36 C181.1,128.28,181.4,127.77,181.78,127.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M181.78,127.55c0.2-0.12,0.38-0.09,0.46,0.03c0.21,0.03,0.35,0.24,0.33,0.54 c-0.02,0.45-0.34,1.63-0.73,1.85c-0.2,0.11-0.37,0.09-0.46-0.04c-0.21-0.06-0.32-0.97-0.29-1.29 C181.14,128.23,181.42,127.76,181.78,127.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M181.79,127.56c0.23-0.13,0.42-0.09,0.5,0.08c0.18,0.04,0.3,0.24,0.28,0.51 c-0.03,0.44-0.34,1.51-0.72,1.73c-0.22,0.12-0.42,0.08-0.49-0.08c-0.18-0.08-0.27-0.91-0.23-1.22 C181.18,128.19,181.45,127.75,181.79,127.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M181.79,127.57c0.25-0.15,0.46-0.08,0.53,0.13c0.16,0.05,0.26,0.24,0.23,0.49 c-0.04,0.43-0.34,1.4-0.71,1.61c-0.25,0.14-0.46,0.07-0.52-0.13c-0.16-0.11-0.22-0.85-0.16-1.15 C181.22,128.15,181.47,127.75,181.79,127.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M181.79,127.57c0.28-0.16,0.51-0.07,0.56,0.17c0.13,0.06,0.21,0.24,0.18,0.47 c-0.05,0.41-0.35,1.28-0.7,1.48c-0.27,0.15-0.5,0.07-0.55-0.18c-0.13-0.13-0.17-0.79-0.1-1.08 C181.26,128.11,181.5,127.74,181.79,127.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M181.8,127.58c0.3-0.17,0.55-0.07,0.59,0.22c0.11,0.08,0.17,0.24,0.14,0.45 c-0.06,0.4-0.35,1.16-0.69,1.36c-0.3,0.17-0.55,0.06-0.59-0.23c-0.11-0.15-0.12-0.73-0.04-1 C181.29,128.07,181.52,127.74,181.8,127.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M181.8,127.59c0.32-0.19,0.59-0.06,0.62,0.27c0.08,0.09,0.12,0.24,0.09,0.43 c-0.07,0.39-0.35,1.04-0.68,1.23c-0.32,0.18-0.59,0.06-0.62-0.27c-0.08-0.17-0.07-0.67,0.03-0.93 C181.33,128.03,181.55,127.73,181.8,127.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M181.81,127.59c0.35-0.2,0.63-0.05,0.65,0.32c0.05,0.1,0.07,0.24,0.04,0.41 c-0.08,0.38-0.35,0.93-0.67,1.11c-0.35,0.2-0.63,0.05-0.65-0.32c-0.05-0.19-0.01-0.61,0.09-0.86 C181.37,127.99,181.57,127.73,181.81,127.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M181.81,127.6c0.37-0.22,0.63-0.04,0.68,0.37c0.01,0.11,0.03,0.24-0.01,0.39 c-0.09,0.36-0.36,0.81-0.66,0.99c-0.37,0.21-0.68,0.04-0.69-0.37c-0.03-0.21,0.04-0.55,0.16-0.79 C181.41,127.95,181.6,127.72,181.81,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.81,127.61c0.4-0.23,0.71-0.04,0.71,0.41c0,0.45-0.31,1-0.71,1.23c-0.4,0.23-0.72,0.04-0.72-0.41 C181.1,128.39,181.42,127.83,181.81,127.61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M181.5,129.46c0.12,0,0.24-0.04,0.37-0.11c0.43-0.25,0.77-0.83,0.77-1.32c0-0.37-0.2-0.61-0.5-0.61 c-0.12,0-0.24,0.04-0.37,0.11c-0.43,0.24-0.77,0.83-0.77,1.32C181,129.22,181.19,129.45,181.5,129.46z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M184.23,128.77c-0.29,0-0.47-1.15-0.47-1.51c0-0.48,0.34-1.06,0.76-1.3c0.12-0.07,0.24-0.11,0.36-0.11 c0.29,0,0.48,0.24,0.48,0.6c0,0.48-0.34,1.98-0.76,2.22C184.46,128.73,184.34,128.77,184.23,128.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M184.51,125.96c0.15-0.09,0.28-0.09,0.39-0.06c0.26,0.06,0.44,0.24,0.43,0.58 c-0.01,0.47-0.34,1.87-0.75,2.1c-0.15,0.09-0.29,0.1-0.4,0.06c-0.27-0.02-0.42-1.09-0.41-1.44 C183.79,126.74,184.11,126.19,184.51,125.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M184.51,125.97c0.17-0.1,0.33-0.1,0.42-0.02c0.24,0.02,0.39,0.24,0.38,0.56 c-0.02,0.46-0.34,1.75-0.74,1.98c-0.18,0.1-0.33,0.1-0.43,0.01c-0.24-0.04-0.37-1.03-0.35-1.37 C183.83,126.7,184.14,126.19,184.51,125.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M184.52,125.98c0.2-0.12,0.37-0.09,0.46,0.03c0.21,0.03,0.35,0.24,0.33,0.53 c-0.02,0.45-0.34,1.63-0.73,1.85c-0.2,0.11-0.37,0.09-0.46-0.03c-0.21-0.06-0.32-0.97-0.29-1.29 C183.87,126.66,184.16,126.18,184.52,125.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M184.52,125.98c0.22-0.13,0.42-0.09,0.49,0.08c0.19,0.04,0.3,0.24,0.28,0.51 c-0.03,0.44-0.35,1.52-0.72,1.73c-0.23,0.13-0.42,0.08-0.49-0.08c-0.19-0.08-0.27-0.91-0.22-1.22 C183.91,126.62,184.19,126.18,184.52,125.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M184.53,125.99c0.25-0.15,0.46-0.08,0.52,0.13c0.16,0.06,0.26,0.24,0.23,0.49 c-0.04,0.42-0.35,1.4-0.71,1.61c-0.25,0.14-0.46,0.08-0.52-0.13c-0.16-0.11-0.21-0.85-0.16-1.15 C183.95,126.58,184.21,126.17,184.53,125.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M184.53,126c0.27-0.16,0.5-0.07,0.56,0.17c0.13,0.07,0.21,0.24,0.18,0.47c-0.05,0.41-0.35,1.28-0.7,1.48 c-0.27,0.16-0.5,0.07-0.55-0.18c-0.13-0.13-0.16-0.79-0.1-1.08C183.99,126.54,184.23,126.17,184.53,126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M184.53,126c0.3-0.17,0.55-0.07,0.59,0.22c0.11,0.08,0.17,0.24,0.13,0.45c-0.06,0.4-0.35,1.16-0.69,1.36 c-0.3,0.17-0.54,0.06-0.59-0.23c-0.11-0.15-0.11-0.73-0.03-1C184.03,126.49,184.26,126.16,184.53,126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M184.54,126.01c0.32-0.19,0.59-0.06,0.62,0.27c0.08,0.09,0.12,0.24,0.08,0.43 c-0.07,0.39-0.36,1.05-0.68,1.24c-0.32,0.19-0.59,0.06-0.62-0.27c-0.08-0.17-0.06-0.67,0.03-0.93 C184.07,126.45,184.28,126.16,184.54,126.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M184.54,126.02c0.34-0.2,0.63-0.05,0.65,0.32c0.05,0.1,0.07,0.25,0.04,0.41 c-0.08,0.38-0.36,0.93-0.67,1.11c-0.35,0.2-0.63,0.05-0.65-0.32c-0.05-0.19-0.01-0.61,0.09-0.86 C184.11,126.41,184.31,126.15,184.54,126.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M184.55,126.02c0.37-0.22,0.63-0.04,0.69,0.36c0.01,0.11,0.03,0.25-0.01,0.39 c-0.1,0.36-0.36,0.81-0.66,0.99c-0.37,0.21-0.67,0.04-0.68-0.37c-0.03-0.21,0.04-0.55,0.16-0.79 C184.14,126.37,184.33,126.15,184.55,126.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,126.03c0.39-0.23,0.72-0.04,0.72,0.41c0,0.45-0.32,1.01-0.72,1.24c-0.4,0.23-0.71,0.04-0.71-0.42 C183.83,126.81,184.15,126.26,184.55,126.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M184.23,127.88c0.12,0,0.24-0.04,0.37-0.11c0.43-0.25,0.76-0.83,0.76-1.32c0-0.37-0.2-0.61-0.5-0.61 c-0.12,0-0.25,0.04-0.37,0.11c-0.42,0.25-0.76,0.83-0.76,1.32C183.73,127.64,183.93,127.88,184.23,127.88z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M186.96,127.2c-0.29,0-0.48-1.15-0.48-1.51c0-0.48,0.34-1.06,0.76-1.3c0.12-0.07,0.25-0.11,0.36-0.11 c0.29,0,0.48,0.24,0.48,0.59c0,0.48-0.34,1.98-0.76,2.22C187.2,127.16,187.07,127.2,186.96,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M187.24,124.38c0.15-0.09,0.29-0.09,0.39-0.06c0.26,0.06,0.44,0.24,0.43,0.57 c-0.01,0.47-0.35,1.86-0.75,2.1c-0.15,0.09-0.3,0.1-0.4,0.06c-0.26-0.02-0.43-1.09-0.42-1.44 C186.52,125.16,186.84,124.61,187.24,124.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M187.25,124.39c0.17-0.1,0.33-0.1,0.43-0.02c0.24,0.02,0.4,0.24,0.38,0.55 c-0.02,0.46-0.35,1.75-0.74,1.98c-0.17,0.1-0.34,0.1-0.43,0.02c-0.24-0.04-0.37-1.03-0.35-1.37 C186.56,125.12,186.87,124.61,187.25,124.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M187.25,124.4c0.2-0.11,0.38-0.09,0.46,0.03c0.21,0.03,0.35,0.24,0.33,0.53 c-0.02,0.45-0.35,1.63-0.73,1.85c-0.2,0.11-0.38,0.09-0.46-0.03c-0.21-0.06-0.32-0.97-0.29-1.3 C186.6,125.08,186.89,124.6,187.25,124.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M187.25,124.41c0.22-0.13,0.42-0.08,0.49,0.08c0.19,0.05,0.31,0.24,0.29,0.51 c-0.03,0.44-0.35,1.51-0.73,1.73c-0.22,0.13-0.42,0.09-0.49-0.08c-0.18-0.08-0.27-0.91-0.23-1.22 C186.64,125.04,186.92,124.6,187.25,124.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M187.26,124.41c0.25-0.14,0.46-0.08,0.53,0.13c0.16,0.06,0.26,0.24,0.24,0.49 c-0.04,0.43-0.35,1.4-0.72,1.61c-0.25,0.14-0.46,0.08-0.52-0.13c-0.16-0.11-0.22-0.85-0.16-1.15 C186.68,125,186.94,124.59,187.26,124.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M187.26,124.42c0.27-0.16,0.51-0.07,0.56,0.17c0.13,0.07,0.21,0.24,0.19,0.47 c-0.05,0.41-0.36,1.28-0.71,1.48c-0.27,0.16-0.51,0.07-0.56-0.18c-0.13-0.13-0.17-0.79-0.1-1.08 C186.72,124.96,186.97,124.59,187.26,124.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M187.27,124.43c0.3-0.17,0.55-0.07,0.59,0.22c0.11,0.08,0.17,0.24,0.14,0.45 c-0.06,0.4-0.36,1.16-0.7,1.36c-0.3,0.17-0.55,0.07-0.59-0.22c-0.11-0.15-0.12-0.73-0.04-1.01 C186.76,124.92,186.99,124.58,187.27,124.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M187.27,124.43c0.32-0.19,0.59-0.06,0.62,0.27c0.08,0.09,0.12,0.25,0.09,0.43 c-0.07,0.39-0.36,1.05-0.69,1.24c-0.32,0.18-0.59,0.06-0.62-0.27c-0.08-0.17-0.07-0.67,0.03-0.93 C186.8,124.88,187.01,124.58,187.27,124.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M187.27,124.44c0.35-0.2,0.63-0.05,0.66,0.32c0.05,0.1,0.07,0.25,0.04,0.41 c-0.08,0.38-0.36,0.93-0.68,1.11c-0.35,0.2-0.63,0.05-0.65-0.32c-0.05-0.19-0.02-0.61,0.09-0.86 C186.84,124.84,187.04,124.57,187.27,124.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M187.28,124.45c0.37-0.21,0.63-0.04,0.69,0.36c0.01,0.11,0.03,0.25-0.01,0.39 c-0.1,0.37-0.37,0.82-0.67,0.99c-0.37,0.21-0.67,0.05-0.68-0.37c-0.03-0.21,0.03-0.55,0.15-0.79 C186.87,124.79,187.06,124.57,187.28,124.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.28,124.45c0.4-0.23,0.72-0.04,0.72,0.41c0,0.45-0.33,1.01-0.72,1.24c-0.4,0.23-0.71,0.04-0.71-0.42 C186.57,125.23,186.88,124.68,187.28,124.45z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M186.96,126.3c0.12,0,0.24-0.04,0.37-0.11c0.44-0.25,0.77-0.83,0.77-1.32c0-0.37-0.19-0.61-0.5-0.61 c-0.12,0-0.24,0.03-0.37,0.11c-0.43,0.25-0.77,0.83-0.77,1.32C186.46,126.06,186.65,126.3,186.96,126.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.5399,
    y1: 136.0533,
    x2: 158.826,
    y2: 134.8167,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2082,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#333540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6432,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8633,
    style: {
      stopColor: "#64666F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A7C83"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M177.4,131.37c0.4-0.23,0.72-0.04,0.72,0.42c0,0.45-0.32,1-0.72,1.23c-0.39,0.23-0.71,0.04-0.71-0.41 C176.69,132.16,177.02,131.6,177.4,131.37z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.8934,
    y1: 135.8711,
    x2: 158.9102,
    y2: 134.1099,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2071,
    style: {
      stopColor: "#252633"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    style: {
      stopColor: "#2D2F3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4344,
    style: {
      stopColor: "#3B3D48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#4F515B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    style: {
      stopColor: "#6A6A74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6845,
    style: {
      stopColor: "#8A8A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8072,
    style: {
      stopColor: "#898A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#64656F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8858,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#333440"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#222431"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M175.84,132.47l1.06,0.6c-0.13-0.07-0.21-0.23-0.21-0.46c0-0.45,0.32-1.01,0.71-1.24 c0.21-0.12,0.39-0.12,0.52-0.05l-1.06-0.6c-0.13-0.07-0.3-0.07-0.5,0.05c-0.4,0.23-0.72,0.78-0.72,1.23 C175.63,132.22,175.71,132.39,175.84,132.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.2695,
    y1: 134.474,
    x2: 161.5544,
    y2: 133.2354,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2082,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#333540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6432,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8633,
    style: {
      stopColor: "#64666F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A7C83"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M180.14,129.8c0.4-0.23,0.72-0.04,0.72,0.41c0,0.45-0.32,1.01-0.72,1.23c-0.4,0.23-0.72,0.04-0.72-0.41 C179.43,130.58,179.74,130.02,180.14,129.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.625,
    y1: 134.2839,
    x2: 161.6382,
    y2: 132.5291,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2071,
    style: {
      stopColor: "#252633"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    style: {
      stopColor: "#2D2F3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4344,
    style: {
      stopColor: "#3B3D48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#4F515B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    style: {
      stopColor: "#6A6A74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6845,
    style: {
      stopColor: "#8A8A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8072,
    style: {
      stopColor: "#898A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#64656F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8858,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#333440"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#222431"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M178.58,130.89l1.05,0.6c-0.13-0.07-0.2-0.24-0.2-0.46c0-0.45,0.32-1.01,0.72-1.24 c0.19-0.12,0.38-0.12,0.51-0.05l-1.06-0.6c-0.13-0.08-0.31-0.07-0.51,0.05c-0.39,0.23-0.71,0.78-0.71,1.23 C178.37,130.65,178.45,130.81,178.58,130.89z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 165,
    y1: 132.8913,
    x2: 164.2843,
    y2: 131.6517,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2082,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#333540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6432,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8633,
    style: {
      stopColor: "#64666F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A7C83"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M182.87,128.22c0.39-0.23,0.72-0.04,0.72,0.41c0,0.45-0.32,1.01-0.72,1.24c-0.4,0.23-0.72,0.04-0.72-0.42 C182.16,129,182.48,128.45,182.87,128.22z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.3496,
    y1: 132.7003,
    x2: 164.3622,
    y2: 130.9463,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2071,
    style: {
      stopColor: "#252633"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    style: {
      stopColor: "#2D2F3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4344,
    style: {
      stopColor: "#3B3D48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#4F515B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    style: {
      stopColor: "#6A6A74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6845,
    style: {
      stopColor: "#8A8A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8072,
    style: {
      stopColor: "#898A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#64656F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8858,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#333440"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#222431"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M181.31,129.31l1.06,0.61c-0.13-0.08-0.2-0.24-0.2-0.46c0-0.45,0.32-1,0.71-1.23 c0.2-0.12,0.38-0.12,0.51-0.05l-1.05-0.6c-0.13-0.08-0.32-0.07-0.51,0.05c-0.4,0.23-0.72,0.78-0.72,1.23 C181.1,129.08,181.18,129.23,181.31,129.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.7282,
    y1: 131.3057,
    x2: 167.0131,
    y2: 130.0672,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2082,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#333540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6432,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8633,
    style: {
      stopColor: "#64666F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A7C83"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M185.6,126.64c0.4-0.23,0.72-0.04,0.72,0.41c0,0.46-0.32,1.01-0.72,1.24c-0.39,0.22-0.71,0.04-0.71-0.42 C184.89,127.42,185.21,126.87,185.6,126.64z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.0821,
    y1: 131.1161,
    x2: 167.0941,
    y2: 129.3633,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2071,
    style: {
      stopColor: "#252633"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    style: {
      stopColor: "#2D2F3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4344,
    style: {
      stopColor: "#3B3D48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#4F515B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    style: {
      stopColor: "#6A6A74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6845,
    style: {
      stopColor: "#8A8A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8072,
    style: {
      stopColor: "#898A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#64656F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8858,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#333440"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#222431"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M184.04,127.73l1.06,0.61c-0.12-0.08-0.2-0.24-0.2-0.47c0-0.45,0.32-1,0.71-1.23 c0.2-0.11,0.38-0.12,0.51-0.05l-1.06-0.61c-0.13-0.08-0.31-0.06-0.51,0.05c-0.4,0.23-0.71,0.78-0.71,1.24 C183.83,127.5,183.91,127.65,184.04,127.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.4522,
    y1: 129.7235,
    x2: 169.7392,
    y2: 128.4885,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2082,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#333540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6432,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8633,
    style: {
      stopColor: "#64666F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A7C83"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M188.34,125.07c0.4-0.23,0.71-0.05,0.71,0.41c0,0.46-0.32,1.01-0.71,1.24c-0.4,0.22-0.72,0.04-0.72-0.41 C187.62,125.84,187.94,125.29,188.34,125.07z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.8096,
    y1: 129.5304,
    x2: 169.8204,
    y2: 127.7796,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 18.5773 -3.6555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2071,
    style: {
      stopColor: "#252633"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    style: {
      stopColor: "#2D2F3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4344,
    style: {
      stopColor: "#3B3D48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5253,
    style: {
      stopColor: "#4F515B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    style: {
      stopColor: "#6A6A74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6845,
    style: {
      stopColor: "#8A8A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8072,
    style: {
      stopColor: "#898A91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8465,
    style: {
      stopColor: "#64656F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8858,
    style: {
      stopColor: "#474954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#333440"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    style: {
      stopColor: "#262835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#222431"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M186.77,126.15l1.06,0.61c-0.13-0.08-0.21-0.24-0.21-0.46c0-0.46,0.32-1.01,0.72-1.23 c0.2-0.12,0.38-0.13,0.51-0.05l-1.06-0.61c-0.13-0.08-0.31-0.06-0.51,0.05c-0.4,0.23-0.71,0.78-0.71,1.24 C186.57,125.92,186.64,126.08,186.77,126.15z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotteaspirante);
export default __webpack_public_path__ + "static/media/Hotte aspirante.29edf286ac67614e98def5cdef549ac2.svg";
export { ForwardRef as ReactComponent };